import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { EquipmentService, EquipmentSummary } from '../../core/services/equipment.service';

/**
 * The equipment catalogue. Copy here is English-only by design — product codes
 * and technical values are not translated, so no Tolgee keys.
 */
@Component({
    selector: 'app-equipment',
    imports: [FormsModule, MenuBarComponent, FooterComponent],
    templateUrl: './equipment.component.html',
    styleUrl: './equipment.component.scss',
})
export class EquipmentComponent implements OnInit {
    equipment: EquipmentSummary[] = [];
    loading = false;
    failed = false;
    search = '';

    constructor(
        private equipmentService: EquipmentService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.load();
    }

    get filtered(): EquipmentSummary[] {
        const q = this.search.trim().toLowerCase();
        if (!q) return this.equipment;
        return this.equipment.filter((e) =>
            (e.code || '').toLowerCase().includes(q) ||
            (e.name || '').toLowerCase().includes(q),
        );
    }

    load(): void {
        this.loading = true;
        this.failed = false;
        this.equipmentService.list().subscribe({
            next: (res) => { this.equipment = res?.equipment ?? []; this.loading = false; },
            error: () => { this.equipment = []; this.loading = false; this.failed = true; },
        });
    }

    public open(item: EquipmentSummary): void {
        this.router.navigate(['/equipment', item.slug]);
    }
}
